import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_TOGGLE_HALAL_STOCK_ACTIVE } from "../../../config/api";
import { getStock } from "./getStock";

export const toggleStockActive = createAsyncThunk(
  "stocks/toggleActive",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_TOGGLE_HALAL_STOCK_ACTIVE(id),
        data: data,
      });
      toast.success(
        data?.is_active
          ? "Stock trading activated"
          : "Stock trading deactivated"
      );
      dispatch(getStock(id));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
